import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

const FORMAT = 'DD MMM YYYY HH:mm';

class FormattedDate extends PureComponent {
	render() {
		return (
			<span>
				{format(new Date(this.props.date), FORMAT)}
			</span>
		);
	}
}

FormattedDate.propTypes = {
	date: PropTypes.string.isRequired
};

export default FormattedDate;



// WEBPACK FOOTER //
// ./src/client/components/admin/common/formatted-date/index.jsx